import styled from 'styled-components'
import {
  background,
  hFlex,
  vFlex,
} from '../../../../../../../../../../../../Styles/style-helpers'
import reviewIllustration from '../../../../../../../../../../../../Assets/Icons/Recorded/reviews.svg'

export const ReviewContainerEl = styled.div`
  padding: 2em 0;
  ${vFlex};

  .illustration {
    width: 50%;
    height: 20em;
    margin: 5em 0;
    ${background(reviewIllustration, 'contain')}
  }
`

export const ReviewEl = styled.div`
  width: 100%;
  border-top: 2px solid #f0f0f0;
  ${hFlex};
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1.5em 2em;
  position: relative;

  .basicInfo {
    ${vFlex};
    align-items: flex-start;
    width: 25%;

    .userInfo {
      ${hFlex};
      margin-bottom: 0.5em;

      > p {
        margin-left: 0.5em;
        text-overflow: ellipsis;
        line-height: 1.5;
      }
    }
  }

  .description {
    width: 75%;
    max-height: 8em;
    overflow-y: auto;

    > p {
      line-height: 1.3;
    }
  }
`
